import {Button, Modal} from 'react-bootstrap';
import React from 'react';

class BlockUrlModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      urlInTab: this.props.urlInTab || false,
      url: this.props.url || ''
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  handleSave(e) {
    if (e) {
      e.preventDefault();
    }

    this.props.setUrl(this.state.url, this.state.urlInTab);
    this.props.onHide();
  }

  handleRemove(e) {
    if (e) {
      e.preventDefault();
    }

    this.props.setUrl('', false);
    this.props.onHide();
  }

  handleInputChange(e) {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }


  render() {
    return (
      <div>
        <Modal
          bsSize="large"
          show={this.props.show}
          backdrop={true}
          onHide={this.props.onHide}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title>Lenke</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <form onSubmit={this.handleSave}>
              <div className="form-group">
                <label>URL</label>
                <input type="text" className="form-control" name="url" value={this.state.url} onChange={this.handleInputChange} autoFocus />
              </div>
              <div className="checkbox">
                <label>
                  <input type="checkbox" name="urlInTab" checked={this.state.urlInTab} onChange={this.handleInputChange} />Åpne i ny fane
                </label>
              </div>
            </form>
          </Modal.Body>

          <Modal.Footer>
            <div className="pull-left">
              <Button
                bsStyle="success"
                onClick={this.handleSave}
              >
                  Lagre
              </Button>
              <Button
                bsStyle="danger"
                onClick={this.handleRemove}
              >
                  Fjern lenke
              </Button>
            </div>
            <Button
              bsStyle="primary"
              onClick={this.props.onHide}
            >
                Avbryt
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

BlockUrlModal.defaultProps = {
  show: true
};

export default BlockUrlModal;
